import { Button, Heading, Section } from 'components'
import React from 'react'

const TempStart = () => {
  return (
    <Section>
      <div className="grid grid-cols-12 gap-24 items-center">
        <div className="space-y-6 col-span-6">
          <Heading type="kicker">Start your Free Trial</Heading>
          <Heading>
            Get started with LeadBoxer and start your free trial
          </Heading>
          <p className="text-xl">
            To start your free trial, you need to create an account
          </p>

          <fieldset className="flex space-x-2 items-stretch">
            <div className="flex-grow">
              <label
                className="uppercase text-xs block mb-2 hidden"
                htmlFor="email"
              >
                Email
              </label>
              <input
                name="email"
                onChange={(e) => {
                  console.log(e)
                }}
                id="email"
                type="text"
                className="border border-gray-300 px-4 py-3 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent w-full"
                placeholder="mail@leadboxer.com"
              />
            </div>
            <input
              name="submit"
              id="submit"
              className="button button--primary flex-grow-0 text-center flex text-lg w-40"
              readOnly
              value="Get Started"
            />
          </fieldset>

          <p>
            Please Enter your business email address and follow the
            instructions.
          </p>
        </div>

        <div className="col-span-6 bg-gray-50 rounded border border-gray-100 p-16 space-y-8">
          <Heading type="kicker">
            Get a personal 1-on-1 demo of LeadBoxer
          </Heading>
          <Heading>Schedule a personal demo</Heading>
          <p className="text-xl">Get a personal 1-on-1 demo of LeadBoxer.</p>
          <p>
            Whether it’s a product walkthrough, specific questions or a casual
            chat on how to gain more insights from your web & email audience –
            our product experts have you covered.
          </p>
          <p>
            Pick the day and time on the right to schedule your 1-on-1 demo.
          </p>
          <div>
            <Button type="primary" to="/demo">
              Schedule a Demo
            </Button>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default TempStart
